export const errorTypes = {
  nameEmpty: 'nameEmpty',
  actionTypeEmpty: 'actionTypeEmpty',
  actionBlockOptionsEmpty: 'actionBlockOptionsEmpty',
  actionDisableForEmpty: 'actionDisableForEmpty',
  actionProductConditionIncomplete: 'actionProductConditionIncomplete',
  actionBonusOptionsEmpty: 'actionBonusOptionsEmpty',
  actionBonusDiscountTypeEmpty: 'actionBonusDiscountTypeEmpty',
  actionBonusDiscountValueEmpty: 'actionBonusDiscountValueEmpty',
  actionBonusDiscountLabelEmpty: 'actionBonusDiscountLabelEmpty',
  actionDisableRefundMethodsEmpty: 'actionDisableRefundMethodsEmpty',
  actionFeeNameEmpty: 'actionFeeNameEmpty',
  actionFeeAmountEmpty: 'actionFeeAmountEmpty',
  actionFeeCurrencyEmpty: 'actionFeeCurrencyEmpty',
  actionRefundMethodEmpty: 'actionRefundMethodEmpty',
  actionRefundTriggerEmpty: 'actionRefundTriggerEmpty',
  actionExchangeTriggerEmpty: 'actionExchangeTriggerEmpty',
  actionExtendConfigIncomplete: 'actionExtendConfigIncomplete',
  actionReasonEmpty: 'actionReasonEmpty',
  actionDelayDaysInvalid: 'actionDelayDaysInvalid',
  actionCustomMessageEmpty: 'actionCustomMessageEmpty',
  actionMessagePlacementEmpty: 'actionMessagePlacementEmpty',
  actionCustomMessageTypeEmpty: 'actionCustomMessageTypeEmpty',
  actionConsentTitleEmpty: 'actionConsentTitleEmpty',
  actionConsentDescriptionEmpty: 'actionConsentDescriptionEmpty',
  actionConsentCheckboxTextEmpty: 'actionConsentCheckboxTextEmpty',
  actionTagsEmpty: 'actionTagsEmpty',
  conditionsEmpty: 'conditionsEmpty',
  conditionIncomplete: 'conditionIncomplete',
}
